import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { classNames } from '../common/utils/utils';

export interface InputProps extends ComponentPropsWithoutRef<'input'> {
  label?: string;
  helper?: ReactNode;
}

const Input = ({ label, helper, type, className, ...props }: InputProps) => {

  return (
    <div
      className={classNames(
        type === 'checkbox' ? 'flex-row-reverse justify-end gap-2' : 'flex-col gap-1',
        'flex',
        'relative'
      )}
    >
      {label && <label htmlFor={`${label}__input`}>{label}</label>}
      <input
        id={`${label}__input`}
        {...props}
        className={classNames(
          type === 'checkbox'
            ? 'block rounded border-gray-400 shadow-sm sm:text-base text-sm disabled:bg-gray-100'
            : '',
          `${className}`,
        )}
        type={type}
      />
      {helper}
    </div>
  );
};

export default Input;
